type PercentageDashboardIconProps = {
  className?: string;
};

export const PercentageDashboardIcon = ({
  className,
}: PercentageDashboardIconProps): React.ReactElement => (
  <svg
    id="menu"
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16.222 16.204"
  >
    <g id="Menu_icon_dashboard">
      <path
        id="Path_212"
        data-name="Path 212"
        d="M3.921,3.592a1.028,1.028,0,0,1,.951,1.077V15.16A1,1,0,0,1,3.921,16.2H.95A1,1,0,0,1,0,15.16V4.669A1.027,1.027,0,0,1,.95,3.592ZM3.886,4.711H.987V15.085h2.9ZM9.6,7.184a1.028,1.028,0,0,1,.951,1.077v6.9A1,1,0,0,1,9.6,16.2H6.625a1,1,0,0,1-.95-1.045v-6.9a1.027,1.027,0,0,1,.95-1.077ZM9.56,8.3h-2.9v6.782h2.9ZM15.271,0a1.028,1.028,0,0,1,.951,1.077V15.16a1,1,0,0,1-.951,1.045H12.3a1,1,0,0,1-.95-1.045V1.077A1.027,1.027,0,0,1,12.3,0Zm-.036,1.119h-2.9V15.085h2.9Z"
        transform="translate(0 0)"
      />
    </g>
  </svg>
);
